/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./downlinksActility.vue?vue&type=template&id=6d6a8d4d&scoped=true"
import script from "./downlinksActility.vue?vue&type=script&lang=js"
export * from "./downlinksActility.vue?vue&type=script&lang=js"
import style0 from "./downlinksActility.vue?vue&type=style&index=0&id=6d6a8d4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6a8d4d",
  null
  
)

export default component.exports